import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Category } from '../../py-generated/datalouder/stock/types';
import { useFavorite } from '../like/useFavorite';
import ShortkeyListener from './ShortkeyListener';

interface Props {
  category: Category;
  ticker: string;
}

const StockShortkeys: React.FC<Props> = ({ category, ticker }) => {
  const [t] = useTranslation();
  const [, toggleLike, , toggleUnlike] = useFavorite();

  const gORb = useCallback(
    key => {
      if (key === 'g') {
        toggleLike(category, ticker);
      }
      if (key === 'b') {
        toggleUnlike(category, ticker);
      }
    },
    [category, ticker, toggleLike, toggleUnlike]
  );

  return (
    <ShortkeyListener
      handleKeys={['g', 'b']}
      onKeyEvent={gORb}
      shortkeys={[
        {
          section: 'peek',
          key: 'G',
          description: t('add-remove-favorite'),
        },
        {
          section: 'peek',
          key: 'B',
          description: t('add-remove-isUnlike'),
        },
      ]}
    />
  );
};

export default React.memo(StockShortkeys);
